import { connect } from 'react-redux';
import { login, resetPassword, sendPasswordRecovery, setContext } from '../../store/actions/auth';
import { dismissError, dismissLoadingSucceeded, isLoading } from '../../store/actions/app';
import { setUserSetting } from '../../store/actions/userSettings';
import Login from '../../components/Pages/Login';
import { getUrlParameter } from '../../util';

const mapStateToProps = state => {

    // console.log( 'containers.pages.Login.mapStateToProps', state );

    return {
        context:            getUrlParameter( 'context' ) || state.auth.context,
        error:              state.app.error,
        language:           state.userSettings.language,
        loading:            state.app.loading,
        loadingSucceeded:   state.app.loadingSucceeded,
        resetPasswordToken: getUrlParameter( 'rpt' )
    };

};

const mapDispatchToProps = dispatch => {

    return {
        onDismissError:            () => dispatch( dismissError() ),
        onDismissLoadingSucceeded: () => dispatch( dismissLoadingSucceeded() ),
        onLogin:                   ( context, username, password ) => dispatch( isLoading( true ) ) && dispatch( login( context, username, password ) ),
        onResetPassword:           ( context, token, password ) => dispatch( isLoading( true ) ) && dispatch( resetPassword( context, token, password ) ),
        onSelectLanguage:          e => dispatch( setUserSetting( 'language', e ) ),
        onSendPasswordRecovery:    ( context, username ) => dispatch( isLoading( true ) ) && dispatch( sendPasswordRecovery( context, username ) ),
        onSetContext:              context => dispatch( setContext( context) )
    };

};

export default connect( mapStateToProps, mapDispatchToProps )( Login );